export default "__VITE_ASSET__BLfzbPqD__"